import moment from 'moment'
import i18n from '@/libs/i18n'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
moment.locale(i18n.locale)
moment.updateLocale(moment.locale(), { invalidDate: '' })

const mixins = {
  computed: {
    getBooleanOptions() {
      return [
        { id: null, name: this.$t('All') },
        { id: '1', name: this.$t('Yes') },
        { id: '0', name: this.$t('No') },
      ].map(field => ({
        ...field,
        title: field.name,
      }))
    },
  },
  methods: {
    isoDateTrimmed(time) {
      return moment(time).format('YYYY-MM-DDTHH:mm')
    },
    isoDate(time) {
      return this.momentFormatIso(moment(time))
    },
    momentFormatIso(mDate) {
      return mDate.format('YYYY-MM-DDTHH:mm:ss')
    },
    longDate(time) {
      return moment(time).format('dddd, D MMMM YYYY HH:mm')
    },
    mediumDate(time) {
      return moment(time).format('DD/MM/YYYY HH:mm')
    },
    shortDate(time) {
      return moment(time).format('DD/MM/YYYY')
    },
    shortDateIso(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    shortTime(time) {
      return moment(time).format('HH:mm')
    },
    isAfterNow(time) {
      return moment(time, 'YYYY-MM-DD HH:mm').isAfter(moment())
    },
    isBeforeNow(time) {
      return moment(time, 'YYYY-MM-DD HH:mm').isBefore(moment())
    },
    showToast(toastProps) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: toastProps,
      })
    },
    stripHtml(string) {
      if (!string) {
        return ''
      }
      return string.replace(/<\/?[^>]+>/gi, ' ')
    },
    blobToBase64(blob) {
      return new Promise(resolve => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(blob)
      })
    },
  },
}

export default mixins
